import {connect} from '@modifi/redux'
import {FeInputFieldStatus} from '@modifi/enums'

import {SectionNavigationItemStatus} from '../../../../plugins/onboarding'
import {
  selectCombinedInputFieldStatusBySectionName,
  selectListInputFieldStatusBySectionName,
} from '../../../../modules/input-fields'
import {selectLegalRepresentatives} from '../../../../data/legal-representatives'
import {selectBeneficialOwners} from '../../../../data/beneficial-owners'
import {selectDirectors} from '../../../../data/directors'
import {selectSellerTradePartnersCount} from '../../../../data/seller-trade-partners'
import {
  SECTION_DIRECTORS,
  SECTION_LEGAL_REPRESENTATIVES,
  SECTION_OVERVIEW,
  SECTION_SELLER_TRADE_PARTNERS,
  SECTION_ULTIMATE_BENEFICIAL_OWNERS,
} from '../../../../constants/sections'
import {
  ItemStatusProps,
  NavigationStatus,
} from '../../../../plugins/onboarding/layout/navigation/item-status'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {sectionName?: string | null}
): ItemStatusProps => {
  const {sectionName} = ownProps

  let status
  let progress

  if (sectionName) {
    const inputFieldStatus = selectCombinedInputFieldStatusBySectionName(state, sectionName)

    if (inputFieldStatus === FeInputFieldStatus.VERIFIED) {
      status = NavigationStatus.APPROVED
    } else if (inputFieldStatus === FeInputFieldStatus.COMPLETED) {
      status = NavigationStatus.FILLED
      progress = 100
    } else {
      status = NavigationStatus.INITIAL_STATE

      if (sectionName === SECTION_OVERVIEW) {
        status = undefined
      } else if (sectionName === SECTION_LEGAL_REPRESENTATIVES) {
        if (selectLegalRepresentatives(state).length > 0) {
          status = NavigationStatus.PARTIALLY_FILLED
          progress = 50
        }
      } else if (sectionName === SECTION_ULTIMATE_BENEFICIAL_OWNERS) {
        if (selectBeneficialOwners(state).length > 0) {
          status = NavigationStatus.PARTIALLY_FILLED
          progress = 50
        }
      } else if (sectionName === SECTION_DIRECTORS) {
        if (selectDirectors(state).length > 0) {
          status = NavigationStatus.PARTIALLY_FILLED
          progress = 50
        }
      } else if (sectionName === SECTION_SELLER_TRADE_PARTNERS) {
        if (selectSellerTradePartnersCount(state) > 0) {
          status = NavigationStatus.PARTIALLY_FILLED
          progress = 50
        }
      } else {
        const inputFieldStatusList = selectListInputFieldStatusBySectionName(state, sectionName)
        if (inputFieldStatusList?.includes(FeInputFieldStatus.COMPLETED)) {
          status = NavigationStatus.PARTIALLY_FILLED
          progress = +(
            (1 -
              inputFieldStatusList.filter(s => s === FeInputFieldStatus.PENDING).length /
                inputFieldStatusList.length) *
            100
          ).toFixed(2)
        }
      }
    }
  }

  return {
    status,
    progress,
  }
}

export default connect(mapStateToProps)(SectionNavigationItemStatus)
